module.exports = __webpack_public_path__ + "img/tu06.2cd4b748.jpg";